<template>
  <Modal
    classContent="congeners-modal"
    :title="'Cadastro de Seguradoras'"
    :active.sync="active"
    @close="active = false"
  >
    <p class="text-lg font-medium">
      Adicione as seguradoras que dispensam a Vistoria Prévia em casos de
      renovação emendada.
    </p>
    <div class="mt-4 flex flex-row gap-4 items-end">
      <v-select
        :options="congenersOptions"
        name="Congêneres"
        label="label"
        id="congeners"
        v-model="congeners"
        class="select-large w-full my-select"
        placeholder="Selecione as congêneres"
        :reduce="(item) => item.value"
        multiple
        searchable
        :close-on-select="false"
      >
        <template #selected-option-container="{ option }">
          <vs-chip
            class="mt-2 ml-1"
            transparent
            color="primary"
            closable
            @click="remove(option.value)"
            >{{ option.label }}
          </vs-chip>
        </template>
        <template #option="{ label, value }">
          <div
            :class="{
              'vs-select--is-selected': congeners.includes(value),
            }"
          >
            <feather-icon
              v-if="congeners.includes(value)"
              icon="CheckCircleIcon"
              class=""
              svgClasses="h-4 w-4"
            ></feather-icon>
            {{ label }}
          </div>
        </template>
      </v-select>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full text-right">
        <vs-button
          @click="closeModal"
          type="gradient"
          color="primary"
          class="mt-5"
        >
          Salvar
        </vs-button>
      </div>
    </div>
  </Modal>
</template>
<script>
import VSelect from 'vue-select';
import autoApi from '@/services/auto.api';
import Modal from '../../components/Modal.vue';
export default {
  name: 'ModalCadastroSeguradoras',
  data() {
    return {
      active: false,
      congeners: [],
      congenersOptions: [],
    };
  },
  components: {
    VSelect,
    Modal
  },
  computed: {},
  mounted() {
    this.getCongenersOptions();
  },
  methods: {
    open(registrations) {
      this.congeners = registrations ? JSON.parse(registrations) : [];
      this.active = true;
    },
    closeModal() {
      this.active = false;
      this.$emit('close', JSON.stringify(this.congeners));
    },
    add() {
      this.congeners.push(this.congeners);
    },
    remove(item) {
      this.congeners = this.congeners.filter((i) => i !== item);
    },
    getCongenersOptions() {
      autoApi
        .getCongeners()
        .then((res) => {
          res.forEach((congener) => {
            this.congenersOptions.push({
              value: congener.susep_code,
              label: congener.name,
            });
          });
        })
        .catch((error) => {
          console.log(error);
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: 'Não foi possível buscar a lista de congêneres',
            color: 'danger',
          });
        });
    },
  },
};
</script>
<style>
.congeners-modal {
  overflow: visible;
}
.vs-select--is-selected {
  color: rgb(0 191 237);
  font-weight: bold;
}
</style>
